import { types } from 'mobx-state-tree';

const Notification = types
  .model('Notification', {
    id: types.optional(types.number, () => Date.now()),
    message: types.string,
    status: types.optional(types.enumeration(['show', 'hide']), 'show'),
    level: types.enumeration(['error', 'warning', 'info']),
    data: types.frozen(),
  })
  .views(self => ({
    get isError() {
      return self.level === 'error';
    },
    get isInfo() {
      return self.level === 'info';
    },
    get isWarning() {
      return self.level === 'warning';
    },
  }))
  .actions(self => {
    const hide = () => {
      self.status = 'hide';
    };
    const show = () => {
      self.status = 'show';
    };
    return {
      hide,
      show,
    };
  });

const NotificationStore = types
  .model('NotificationStore', {
    data: types.optional(types.array(Notification), []),
  })
  .actions(self => {
    const raise = ({ message, data, level }) => {
      // cap at 3 elements
      if (self.data.length >= 3) {
        const cp = self.data;
        cp.shift();
        self.data = cp;
      }
      self.data.push(
        Notification.create({
          level,
          message,
          data,
        }),
      );
    };
    const raiseError = (message, data) => {
      raise({ message, data, level: 'error' });
    };
    const raiseInfo = (message, data) => {
      raise({ message, data, level: 'info' });
    };
    const raiseWarning = (message, data) => {
      raise({ message, data, level: 'warning' });
    };
    const clear = () => {
      self.data = [];
    };
    return {
      raiseError,
      raiseInfo,
      raiseWarning,
      clear,
    };
  });

export { NotificationStore };
